import React from 'react';
import { Grid, Typography, Link, Container } from '@mui/material';
import { Twitter, Instagram } from '@mui/icons-material';
import YouTubeIcon from '@mui/icons-material/YouTube';


export default function CopyRight() {
    return (
        <div className='copyright'>
            <Container>
                <Grid container justifyContent="space-between" alignItems="center" className='copy_right_flex'>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" className='description'>
                            © Copyright 2024 RXpose
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container alignItems="center" justifyContent={"right"} gap={"16px"} className='social_media'>

                            <Link href="#" color="inherit">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg>
                            </Link>


                            <Link href="#" color="inherit">
                                <Twitter />
                            </Link>


                            <Link href="#" color="inherit">
                                <Instagram />
                            </Link>


                            <Link href="#" color="inherit">
                                <YouTubeIcon />
                            </Link>

                        </Grid>
                    </Grid>

                </Grid>
            </Container>
        </div>
    )
}
